module.exports = __webpack_public_path__ + "img/flag-checkered-solid-orange.e68e52f2.svg";